import trigger from './trigger';

export default trigger;
